import { type Coordinate, type Geofence, type GeofenceCategory, type GeofenceGeoJSON, Haversine, type TimestampInMillis, type UUID } from '@cobliteam/common-types';

export class GeofenceEntity implements Geofence {
  public id: UUID = '';

  public name = '';

  public address = '';

  public centerLatLong?: Coordinate;

  public radius = 200;

  public createdAt: TimestampInMillis = 0;

  public geojson?: GeofenceGeoJSON;

  public category?: Geofence['category'];

  constructor(
    id: UUID,
    address: string,
    name: string,
    radius: number,
    createdAt: TimestampInMillis,
    centerLatLong?: Coordinate,
    geojson?: GeofenceGeoJSON,
    category?: GeofenceCategory
  ) {
    this.id = id;
    this.address = address;
    this.name = name;
    this.category = category;
    this.radius = radius;
    this.createdAt = createdAt;

    if (centerLatLong) {
      this.centerLatLong = centerLatLong;
      const coordinates = Haversine.pointsOnCircle(this.radius, this.centerLatLong);

      this.geojson = {
        // fallback for any new geojson properties that may happen in the future,
        // but the current idea is to recreate geoJSON object
        ...geojson,
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [coordinates],
        },
        properties: {
          address,
          name,
          radius,
          coordinate: [centerLatLong.longitude, centerLatLong.latitude],
        },
      };
    }
  }
}
